<div class="form">
  <div class="dx-fieldset">
    <div style="font-size: large; font-weight: bold">
      <span appI18n>Stai editando le configurazioni di:</span>
      <b style="color: var(--fg)"> {{ gridId }}</b>
    </div>
    <button
      mat-raised-button
      color="primary"
      (click)="sqlEdit()"
      style="margin: 8px 0"
    >
      Edita Sql
    </button>
    <div class="dx-fieldset-header" style="font-size: large">
      <span appI18n
        >Le configurazioni attualmente salvate sul database sono:</span
      >
      <b style="color: var(--fg)"> {{ confAvailable }}</b>
    </div>
    <!-- Seleziona Tipo Device -->
    @if (gridId) {
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 60%">
        <span appI18n>Tipo configurazione</span>
      </div>
      <div class="dx-field-value" style="width: 40%">
        <dx-select-box
          [showClearButton]="true"
          #selectBoxTipoScrolling
          [items]="gridPerspectives"
          [(value)]="deviceTypeConf"
          [displayExpr]="'description'"
          style="width: calc(100% - 56px); display: inline-block"
        ></dx-select-box>
        <dx-button icon="add" (onClick)="createPerspective()"> </dx-button>
        @if (deviceTypeConf.id) {
        <dx-button icon="edit" (onClick)="editPerspective()"> </dx-button>
        }
      </div>
    </div>
    } @if (confLoaded) {
    <div class="dx-fieldset-header">
      <span appI18n
        >La configurazione è stata caricata. Ecco le tue opzioni:</span
      >
    </div>
    }

    <!-- visualizza Configurazione Grid -->
    @if (confLoaded) {
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 60%">
        <i style="color: var(--sia-green)"
          ><b appI18n
            >1) Visualizza la configurazione attuale della griglia</b
          ></i
        >
      </div>
      <div class="dx-field-value" style="width: 40%">
        <dx-button
          stylingMode="contained"
          type="normal"
          [width]="150"
          (onClick)="viewConfigClick()"
          style="margin-right: 2px"
        >
          <span appI18n class="dx-button-text">Visualizza</span>
        </dx-button>
      </div>
    </div>
    } @if (confLoaded) {
    <div class="dx-field"></div>
    }
    <!-- Reset Configurazione Grid -->
    <!-- Clona Configurazione Grid -->
    @if (confLoaded && deviceTypeConf) {
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 60%">
        <span appI18n
          >2) Clona la configurazione della griglia da un'altra esistente</span
        >
      </div>
      <!-- #selectBoxTipoScrolling -->
      <div class="dx-field-value" style="width: 40%">
        <dx-select-box
          [showClearButton]="true"
          [dataSource]="existingConfigurations"
          [(value)]="cloneConf"
          displayExpr="fullDescription"
          searchMode="contains"
          searchExpr="fullDescription"
          [searchTimeout]="200"
          [minSearchLength]="0"
          [searchEnabled]="true"
          fieldTemplate="field"
        >
          <div *dxTemplate="let data of 'field'">
            <div>
              <dx-text-box [value]="getDataDescription(data)"> </dx-text-box>
            </div>
          </div>
          <div *dxTemplate="let data of 'item'">
            <span style="color: var(--fg)">{{
              data.componentId + ' ' + data.description
            }}</span>
          </div>
        </dx-select-box>
      </div>
    </div>
    }
    <!-- Conferma Clonazione -->
    @if (cloneReady()) {
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 60%">
        <i style="color: var(--sia-red)"
          ><b> {{ opDescription }}</b></i
        >
      </div>
      <div class="dx-field-value" style="width: 40%">
        <dx-button
          stylingMode="contained"
          type="normal"
          [width]="150"
          (onClick)="cloneConfigClick()"
          style="margin-right: 2px"
        >
          <span appI18n class="dx-button-text">Clona</span>
        </dx-button>
      </div>
    </div>
    }
    <!-- Esporta configurazione -->
    @if (confLoaded && deviceTypeConf) {
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 60%">
        <span appI18n> 3) Esporta la configurazione della griglia </span>
      </div>
      <div class="dx-field-value" style="width: 40%">
        <dx-button
          style="margin-right: 2px"
          stylingMode="contained"
          type="normal"
          [text]="'salva in remoto' | siaTranslate"
          (onClick)="remoteSaveGridConfigFile()"
          [width]="150"
        >
        </dx-button>
        <dx-button
          style="margin-right: 2px"
          stylingMode="contained"
          type="normal"
          [text]="'salva' | siaTranslate"
          (onClick)="localSaveGridConfigFile()"
          [width]="150"
        >
        </dx-button>
        <dx-button
          style="margin-right: 2px"
          stylingMode="contained"
          type="normal"
          [text]="'copia' | siaTranslate"
          [cdkCopyToClipboard]="gridConfigJson"
          [width]="150"
        >
        </dx-button>
      </div>
    </div>
    }
  </div>
</div>

<!-- [value]="'('+ {{ data.deviceType }}+ '| siaTranslate'+ {{ data.gridId }}" -->
